const SCROLLING = new Set(["auto", "scroll", "overlay"]);

/**
 * The element that scrolls `list`: the list itself when it has its own scroll region (the upload card's
 * file strip, the recipient list), otherwise the nearest ancestor that scrolls (a transfer's files,
 * which scroll with the sheet around them). Null when nothing does, in which case the list is drawn in
 * full rather than windowed against a scroller it cannot observe.
 *
 * "Scrolls" means its content overflows it, not only that its style allows scrolling. A scroll region
 * whose height is not capped grows with its rows and never scrolls; the sender's file list is one below
 * 520px of window height, where the create card drops its cap and the page scrolls instead
 * (kitecorp/transferify-ui#2958). Windowed against such a region, the list would count every row as in
 * view and draw all 10,000. When nothing around the list overflows yet, the nearest region that may scroll
 * is the answer, as before: the list then fits, and whichever region it is, every row is in view.
 *
 * Read from computed style rather than taken as a ref from each caller, so a list needs no knowledge of
 * which container a restyle might make it scroll inside.
 */
export function scrollContainerOf(list: Element | null): HTMLElement | null {
	let nearest: HTMLElement | null = null;
	for (let node = list; node !== null; node = node.parentElement) {
		if (node instanceof HTMLElement && SCROLLING.has(getComputedStyle(node).overflowY)) {
			if (node.scrollHeight > node.clientHeight) {
				return node;
			}
			nearest ??= node;
		}
	}
	return nearest;
}
